module.exports = __webpack_public_path__ + "static/media/Mulish-Bold.2deb8483.ttf";